export default class SpecificTimeController {
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }
}



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/time-period/specific-time/specific-time.controller.js